import { get, post } from './http-provider';

export const SERVICE_URLS = {
  verifyGeneralOtp: 'Verification/verify-otp',
  generateGeneralOtp: 'Verification/generate-otp?type=',
  logout: 'auth/logout',
  getConfigurationSettings: 'general-setting/configuration-settings',
  initiateCorporateKyc: 'CorporateKycUpdate/InitiateKyc',
  getCorporateDropdowns: 'CorporateKycUpdate/all-dropdown?LanguageId=',
  getCorporateKycData: 'CorporateKycUpdate/GetAllKycData?clientApplicationId=',
  saveCorporateKycData: 'CorporateKycUpdate/kyc-save',
  submitCorporateKyc: 'CorporateKycUpdate/kyc-submit',
  uploadKycDocument: 'CorporateKycUpdate/SaveCorpClientDocuments',
  deleteKycDocument: 'CorporateKycUpdate/DeleteKycDocuments?documentPayloadId=',
  downloadKycDocument: 'CorporateKycUpdate/DocumentDownload/',
  submitKycForm: 'CorporateKycUpdate/kyc-submit',
  getRejectionSummary: 'CorporateKycUpdate/rejection-summary/',
  getFieldCodes: "CorporateKycUpdate/field-code-mappings",
  fetchDocument: "CorporateKycUpdate/fetchfatcaandcrsdocument",
  deleteDraftKyc: "CorporateKycUpdate/DeleteDraftApplication",
  validateIbanKyc: "CorporateKycUpdate/validate-iban",
  createBlankApplication: "CorporateOAO/create-blank-application",
  generateAccountOtp: "CorporateOAO/generate-otp",
  verifyAccountOtp: "CorporateOAO/verify-otp",
  getApplicationTypeDropdown: "CorporateOAO/applicant-type-dropdown?languageId=",
  saveAccountOpeningData: "CorporateOAO/aoa-save",
  submitAccountOpeningData: "CorporateOAO/aoa-submit",
  uploadCorporateClientDocuments: "CorporateOAO/SaveCorpClientDocuments",
  downloadAccountOpeningDocument: "CorporateOAO/DocumentDownload/",
  deleteAccountOpeningDocument: "CorporateOAO/DeleteAOADocuments?documentPayloadId=",
  saveAccountOperation: "CorporateOAO/SaveAccountOperation",
  getAccountOpeningRejectionSummary: 'CorporateOAO/rejection-summary/',
  getAccountOpeningFieldCodes: "CorporateOAO/field-code-mappings?languageId=",
  deleteAccountOpeningDraftKyc: "CorporateOAO/DeleteDraftApplication",
  validateAccountOpeningIban: "CorporateOAO/validate-iban",
  fetchAccountOpeningDocument: "CorporateOAO/fetchfatcaandcrsdocument?languageId=",
  nafathVerification: "CorporateOAO/nafath/session",
  getNafathStatus: "CorporateOAO/nafath/status/",
  downloadAccountOpeningTerms: "CorporateOAO/terms-and-conditions",
  downloadTargetedProductTerms: "CorporateOAO/terms-and-conditions/targeted-product",
  getAccountOpeningForm: "CorporateOAO/GetAllAccountOpeningData?languageId=",
  getAccountOpeningDropdowns: "CorporateOAO/all-dropdown?languageId=",
};

const verifyGeneralOtp = (data) => post(SERVICE_URLS.verifyGeneralOtp, data);
const generateGeneralOtp = (params) => get(SERVICE_URLS.generateGeneralOtp + params);
const logout = (data) => post(SERVICE_URLS.logout, data);
const getConfigurationSettings = () => get(SERVICE_URLS.getConfigurationSettings);
const initiateCorporateKyc = (data) => post(SERVICE_URLS.initiateCorporateKyc, data);
const getCorporateDropdowns = (id) => get(SERVICE_URLS.getCorporateDropdowns + id);
const getCorporateKycData = (id) => get(SERVICE_URLS.getCorporateKycData + id);
const saveCorporateKycData = (data) => post(SERVICE_URLS.saveCorporateKycData, data);
const submitCorporateKyc = (data) => post(SERVICE_URLS.submitCorporateKyc, data);
const uploadKycDocument = (data) => post(SERVICE_URLS.uploadKycDocument, data, true);
const deleteKycDocument = (id) => post(SERVICE_URLS.deleteKycDocument + id);
const downloadKycDocument = (id) => get(SERVICE_URLS.downloadKycDocument + id);
const submitKycForm = (data) => post(SERVICE_URLS.submitKycForm, data);
const getRejectionSummary = (id) => get(SERVICE_URLS.getRejectionSummary + id);
const getFieldCodes = () => get(SERVICE_URLS.getFieldCodes);
const fetchDocument = () => get(SERVICE_URLS.fetchDocument)
const deleteDraftKyc = (data) => post(SERVICE_URLS.deleteDraftKyc, data)
const validateIbanKyc = (data) => post(SERVICE_URLS.validateIbanKyc, data)
const submitAccountOpeningData = (data) => post(SERVICE_URLS?.submitAccountOpeningData, data)
const createBlankApplication = (data) => post(SERVICE_URLS.createBlankApplication, data)
const generateAccountOtp = (data) => post(SERVICE_URLS.generateAccountOtp, data)
const verifyAccountOtp = (data) => post(SERVICE_URLS.verifyAccountOtp, data)
const getApplicationTypeDropdown = (id) => get(SERVICE_URLS.getApplicationTypeDropdown + id)
const saveAccountOpeningData = (data) => post(SERVICE_URLS?.saveAccountOpeningData, data)
const uploadCorporateClientDocuments = (data) => post(SERVICE_URLS?.uploadCorporateClientDocuments, data, true)
const downloadAccountOpeningDocument = (data) => get(SERVICE_URLS?.downloadAccountOpeningDocument + `${data?.payloadId}?languageId=${data?.languageId}`)
const deleteAccountOpeningDocument = (data) => post(SERVICE_URLS?.deleteAccountOpeningDocument + `${data?.documentPayloadId}&languageId=${data?.languageId}`)
const saveAccountOperation = (data) => post(SERVICE_URLS.saveAccountOperation, data, true)
const getAccountOpeningRejectionSummary = (data) => get(SERVICE_URLS.getAccountOpeningRejectionSummary + `${data?.applicationId}?languageId=${data?.languageId}`)
const getAccountOpeningFieldCodes = (id) => get(SERVICE_URLS.getAccountOpeningFieldCodes + id)
const deleteAccountOpeningDraftKyc = (data) => post(SERVICE_URLS.deleteAccountOpeningDraftKyc, data)
const validateAccountOpeningIban = (data) => post(SERVICE_URLS.validateAccountOpeningIban, data)
const fetchAccountOpeningDocument = (id) => get(SERVICE_URLS.fetchAccountOpeningDocument + id)
const nafathVerification = (data) => post(SERVICE_URLS.nafathVerification, data)
const getNafathStatus = (params) => get(SERVICE_URLS.getNafathStatus + params)
const downloadAccountOpeningTerms = (data) => get(SERVICE_URLS.downloadAccountOpeningTerms + `?languageId=${data?.languageId}&documentType=${data?.documentType}`)
const downloadTargetedProductTerms = (data) => get(SERVICE_URLS.downloadTargetedProductTerms + `?documentType=${data?.documentType}&languageId=${data?.languageId}`)
const getAccountOpeningForm = (id, data) => get(SERVICE_URLS.getAccountOpeningForm + id, data)
const getAccountOpeningDropdowns = (id) => get(SERVICE_URLS.getAccountOpeningDropdowns + id)

const apiServices = {
  getAccountOpeningDropdowns,
  getAccountOpeningForm,
  verifyGeneralOtp,
  generateGeneralOtp,
  logout,
  getConfigurationSettings,
  initiateCorporateKyc,
  getCorporateDropdowns,
  getCorporateKycData,
  saveCorporateKycData,
  submitCorporateKyc,
  uploadKycDocument,
  deleteKycDocument,
  downloadKycDocument,
  submitKycForm,
  getRejectionSummary,
  getFieldCodes,
  fetchDocument,
  deleteDraftKyc,
  validateIbanKyc,
  submitAccountOpeningData,
  createBlankApplication,
  generateAccountOtp,
  verifyAccountOtp,
  getApplicationTypeDropdown,
  saveAccountOpeningData,
  uploadCorporateClientDocuments,
  downloadAccountOpeningDocument,
  deleteAccountOpeningDocument,
  saveAccountOperation,
  getAccountOpeningRejectionSummary,
  getAccountOpeningFieldCodes,
  deleteAccountOpeningDraftKyc,
  validateAccountOpeningIban,
  fetchAccountOpeningDocument,
  nafathVerification,
  getNafathStatus,
  downloadAccountOpeningTerms,
  downloadTargetedProductTerms,
};

export default apiServices;
